var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticleIconGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.003,
    height: 24.312,
    viewBox: "0 0 31.003 24.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "picto_actu",
    "data-name": "picto actu",
    transform: "translate(-322 -250.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "articles",
    transform: "translate(-718.141 42.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_228",
    "data-name": "Trac\\xE9 228",
    d: "M1070.485,223.088a1.4,1.4,0,0,0-1.441.129l-8.517,5.364a.623.623,0,0,0,.664,1.055l8.517-5.364a.587.587,0,0,1,.166-.077.581.581,0,0,1,.023.182,2.136,2.136,0,0,1-.853,1.546l-8.257,5.2a.77.77,0,0,1-1.334-.736,4.837,4.837,0,0,1,2-3.62l9.4-5.92a.624.624,0,0,0,0-1.055l-18.066-11.376a.627.627,0,0,0-.664,0l-9.516,5.993a5.79,5.79,0,0,0-2.466,4.466v.27a5.788,5.788,0,0,0,2.466,4.466l14.154,8.913a.621.621,0,0,0,.859-.195.624.624,0,0,0-.195-.86l-14.154-8.912a4.562,4.562,0,0,1-1.884-3.412v-.27a4.561,4.561,0,0,1,1.884-3.412l9.184-5.783,16.9,10.639-8.564,5.392a6.06,6.06,0,0,0-2.58,4.674,2.174,2.174,0,0,0,.994,2.033,1.729,1.729,0,0,0,.848.214,2.645,2.645,0,0,0,1.4-.455l8.258-5.2a3.374,3.374,0,0,0,1.436-2.6A1.4,1.4,0,0,0,1070.485,223.088Z",
    transform: "translate(0 0)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_229",
    "data-name": "Trac\\xE9 229",
    d: "M1066.76,221.826a.623.623,0,0,0,.332-1.151l-11.719-7.38a.623.623,0,1,0-.664,1.055l11.719,7.38A.627.627,0,0,0,1066.76,221.826Z",
    transform: "translate(-2.585 -0.884)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_230",
    "data-name": "Trac\\xE9 230",
    d: "M1065.78,224.416a.623.623,0,0,0,.332-1.151l-4.951-3.1a.624.624,0,0,0-.859.2.623.623,0,0,0,.2.859l4.951,3.1A.614.614,0,0,0,1065.78,224.416Z",
    transform: "translate(-3.634 -2.127)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_231",
    "data-name": "Trac\\xE9 231",
    d: "M1063.627,224.905l-4.99-3.115a.623.623,0,0,0-.858.2.625.625,0,0,0,.2.859l4.99,3.115a.625.625,0,0,0,.329.094.623.623,0,0,0,.331-1.151Z",
    transform: "translate(-3.177 -2.422)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_232",
    "data-name": "Trac\\xE9 232",
    d: "M1051.2,214.917l-4.215,2.654a.624.624,0,0,0,0,1.057l5.027,3.125a.614.614,0,0,0,.329.094.624.624,0,0,0,.339-.1l2.935-1.9a.652.652,0,0,0,.068-.038l1.136-.735a.623.623,0,0,0-.007-1.051l-4.951-3.1A.627.627,0,0,0,1051.2,214.917Zm4.118,3.637-2.98,1.933-3.846-2.39,3.041-1.915Z",
    transform: "translate(-1.187 -1.177)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_233",
    "data-name": "Trac\\xE9 233",
    d: "M1061.419,226.933a.619.619,0,0,0-.278-.387l-5.026-3.126a.624.624,0,0,0-.859.2.622.622,0,0,0,.2.858l5.027,3.126a.623.623,0,0,0,.936-.671Z",
    transform: "translate(-2.72 -2.717)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_234",
    "data-name": "Trac\\xE9 234",
    d: "M1044.562,220.165a.623.623,0,0,0,.2.858l12.407,7.715a.623.623,0,0,0,.658-1.059l-12.408-7.715A.623.623,0,0,0,1044.562,220.165Z",
    transform: "translate(-0.784 -2.092)",
    fill: "#bfbfbf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleIconGrey);
export default __webpack_public_path__ + "static/media/article-icon-grey.eb0e0a8d851a1e569f48174b489ac0e6.svg";
export { ForwardRef as ReactComponent };